import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ThankYou() {
  const orderIDs = JSON.parse(localStorage.getItem("orderIDs")) || [];
  const cart = JSON.parse(localStorage.getItem("checkoutCart")) || [];
  const email = localStorage.getItem("customerEmail");
  
  const baseUrl = "https://wildcard.introducingjeffrey.com/purchases";

  const [cardData, setCardData] = useState([]);
  const navigate = useNavigate();
  const [showPreviewModal, setShowPreviewModal] = useState(false);


  useEffect(() => {
    if (orderIDs.length && cart.length) {
      const expanded = [];
      const idsCopy = [...orderIDs];

      cart.forEach((item) => {
        for (let i = 0; i < item.quantity; i++) {
          const customization = item.customization?.[i] || {};
          const orderID = idsCopy.shift();
          if (!orderID) return;

          const qrGenerated = new Date(parseInt(orderID.substring(0, 13)));
          const qrExpireDate = new Date(qrGenerated);
          qrExpireDate.setDate(qrExpireDate.getDate() + 30);

          expanded.push({
            id: orderID,
            title: item.UITitle,
            pdfLink: `${baseUrl}/${orderID}-final.pdf`,
            jpgLink: `${baseUrl}/${orderID}.jpg`,
            recipientName: customization.recipientName || null,
            recipientEmail: customization.recipientEmail || null,
            video: customization.video || null,
            expireDate: qrExpireDate.toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric"
            })
          });
        }
      });

      setCardData(expanded);
    }
  }, []);

  return (
    <div className="thankyou-wrapper">
      <img
        src="../logo/WildCard_Logo.png"
        alt="WildCard logo"
        className="logo centered-logo"
      />
      <h2 className="thankyou-title">🎉 Thank You for Your Purchase!</h2>
      <p className="thankyou-subtext">
          Your personalized Wild Card{cardData.length === 1 ? " is" : "s are"} ready below.
      </p>

      <div className="thankyou-button-row">
        <button className="wizard-button" onClick={() => navigate("/")}>
          🎁 Pick Another Wild Card
        </button>
      </div>

      {cardData.map((card, i) => (
        <div className="thankyou-card" key={i}>
          <div className="thankyou-card-header">
            <h3>Download {card.title}</h3>
          </div>

          <div className="thankyou-card-middle">
          <img
            src={card.jpgLink}
            alt={`Preview of ${card.title}`}
            width="140"
            height="180"
            className="thankyou-preview"
          />
          <div className="thankyou-card-info">
            <h4>Order ID: {card.id}</h4>
            <p><strong>QR Code Expires:</strong> {card.expireDate}</p>
            {card.recipientName && (
              <p><strong>To:</strong> {card.recipientName}</p>
            )}
            {card.video && (
              <div style={{ marginBottom: "0.5rem" }}>
                <strong>Custom Video:</strong>
                <button
                  className="preview-button"
                  onClick={() => {
                    setPreviewUrl(card.video);
                    setShowPreviewModal(true);
                  }}
                  style={{
                    marginLeft: "0.5rem",
                    fontSize: "0.85rem",
                    background: "none",
                    border: "none",
                    color: "#0077cc",
                    cursor: "pointer",
                    textDecoration: "underline"
                  }}
                >
                  ▶ Preview
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="download-row">
            <a
              href={card.pdfLink}
              target="_blank"
              rel="noopener noreferrer"
              className="thankyou-download-link"
            >
              📥 Print a PDF (8.5x11)
            </a>
            <a
              href={card.jpgLink}
              target="_blank"
              rel="noopener noreferrer"
              // download
              className="thankyou-download-link"
            >
              📥 Open JPG (5x7)
            </a>
          </div>
        </div>
      ))}

      {/**THIS IS THE VIDEO PREVIEW MODAL POP UP */}
      {showPreviewModal && previewUrl && (
        <div className="modal-wrapper" onClick={() => setShowPreviewModal(false)}>
          <div className="modal-shell" onClick={(e) => e.stopPropagation()}>
            <video
              src={previewUrl}
              controls
              style={{ maxWidth: "100%", borderRadius: "8px" }}
            />
            <button
              className="wizard-button"
              style={{ marginTop: "1rem" }}
              onClick={() => setShowPreviewModal(false)}
            >
              Close Preview
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
